<template>
  <div id="app" :class="storeState.lp">
    <div v-if="holding" class="holding">
      <img src="./assets/speedy-loans-logo.png">
      <p>
        SpeedyLoans is currently down for maintenance
      </p>
    </div>
    <div v-else>
      <!-- <NavBar/> -->
      <div class="warning-late">
        <p>Warning: Late repayment can cause you serious money problems. For help, go to <a href="https://www.moneyadviceservice.org.uk/" target="_blank">moneyadviceservice.org.uk</a></p>
      </div>
      <nav class="navbar" role="navigation" aria-label="main navigation">
      <!-- <nav class="navbar is-fixed-top" role="navigation" aria-label="main navigation"> -->
        <div class="container">
          <div class="navbar-brand">
            <router-link to="/" class="navbar-item">
              <img src="./assets/speedy-loans-logo.png">
            </router-link>

            <a role="button" class="navbar-burger burger" aria-label="menu" aria-expanded="false"
               data-target="navbarSpeedyLoans" @click="toggleMenu" :class="{'is-active': navIsActive}">
              <span aria-hidden="true"></span>
              <span aria-hidden="true"></span>
              <span aria-hidden="true"></span>
            </a>
          </div>

          <div id="navbarSpeedyLoans" class="navbar-menu" :class="{'is-active': navIsActive}">
            <div class="navbar-end">
              <router-link to="/" class="navbar-item">Home</router-link>
              <router-link to="/obligations" class="navbar-item">Your Obligations</router-link>
              <router-link to="/how-it-works" class="navbar-item">How It Works</router-link>
              <router-link to="/faq" class="navbar-item">FAQ</router-link>
              <router-link to="/terms-conditions" class="navbar-item">Terms &amp; Conditions</router-link>
              <router-link to="/privacy-policy" class="navbar-item">Privacy Policy</router-link>
              <router-link to="/contact" class="navbar-item">Contact Us</router-link>
            </div>
          </div>
        </div>
      </nav>

      <transition name="fadep">
        <router-view/>
      </transition>

      <svg width="500" height="80" viewBox="0 0 500 80" preserveAspectRatio="none" class="before-a before-a--footer">
        <path d="M0,0 L0,40 Q250,80 500,40 L500,0 Z" fill="black" />
      </svg>
      <!-- <img src="./assets/footer-before.png" class="footer-before"> -->
      <footer class="footer">
        <div class="container">
          <div class="footer-logos">
            <img src="./assets/speedy-loans-logo.png" class="footer-logo">
            <!-- <img src="./assets/feefo.png" class="feefo-logo"> -->
          </div>
          <div class="content">
            <p v-if="false" class="footer-links">
              <router-link to="/short-term-loans" class="footer-item">Short Term Loans</router-link>
              <router-link to="/direct-lender-loans" class="footer-item">Direct Lender Loans</router-link>
              <router-link to="/bad-credit-loans" class="footer-item">Bad Credit Loans</router-link>
              <router-link to="/payday-loans" class="footer-item">Payday Loans</router-link>
              <router-link to="/same-day-loans" class="footer-item">Same Day Loans</router-link>
              <router-link to="/instant-cash-loans" class="footer-item">Instant Cash Loans</router-link>
            </p>
            <p class="footer-links">
              <router-link to="/terms-conditions" class="footer-item">Terms and conditions</router-link>
              <router-link to="/privacy-policy" class="footer-item">Privacy Policy</router-link>
            </p>
            <p>
              Speedy Loans is a trading name of Your Media Limited. Registered Address: 76 St Johns Road, Turnbridge Wells, Kent, TN4 9PH, United Kingdom. Company Registered Number: 06062710. Financial Services Register Number: 842170. ICO Registration Number: ZA504159.
            </p>
            <p>
              Your Media Limited is an Introducer Appointed Representative of Nouveau Finance Limited. Nouveau Finance Limited is authorised and regulated by the Financial Conduct Authority, entered on the Financial Services Register under reference number 842170, and licensed by the Information Commissioner’s Office under reference number ZA504159. Speedy Loans does not make credit decisions and is not a lender. Speedy Loans introduces customers to Nouveau Finance Limited, who match customer’s loan applications with lenders on their panel, based on the information you provide. Speedy Loans may receive commissions for introductions. This website does not directly endorse a particular product or service. Information on our website should be taken as opinion only. Loans for UK based customers only. Loans are subject to status and satisfactory affordability checks. Over 18’s only. Default charges may apply if you do not repay on time. Short term loans are not suitable for longer term borrowing needs.
            </p>
            <p>
              Speedy Loans is a loan matching service. This website will submit the information you provide to a direct lender. Upon loan approval, a direct lender may require further information from yourself which will be collected after we transfer you to their website or they may contact you via phone or email or both.
            </p>
            <p>
              Auto Decisioning allows lenders to make a decision on your loan application without the need for human interaction, for more information please contact your lender or see their privacy policy.
            </p>
            <p>
              (*) Cash Paid in 10 Minutes - Subject to final approval, you could get cash into your account in as little as 10 minutes. This is subject to any final checks, deposits and clearing times as outlined in your loan agreement.
            </p>
            <p>
              (**) All loan applications are subject to traditional credit checks and affordability assessments in accordance with lender's responsible lending policies.
            </p>
          </div>
        </div>
      </footer>
    </div>
  </div>
</template>

<script>
// import NavBar from '@/components/NavBar.vue';
import store from './store';

export default {
  name: 'App',
  // components: {
  //   NavBar,
  // },
  data() {
    return {
      storeState: store.state,
      navIsActive: false,
      holding: true,
    };
  },
  methods: {
    toggleMenu() {
      // console.log(this.navIsActive);
      this.navIsActive = !this.navIsActive;
    },
  },
  watch: {
    '$route'() {
      this.navIsActive = false;
    },
  },
};
</script>

<style lang="scss">
$navbar-breakpoint: 7000px;
$widescreen-enabled: false;
$fullhd-enabled: false;
@import '../node_modules/buefy/src/scss/buefy-build.scss';
@import url('https://fonts.googleapis.com/css?family=Nunito:400,700,800');
$primary: #ae33b5;
// @import "~bulma/sass/utilities/_all";
// $navbar-breakpoint: $tablet;

.holding {
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  padding: 1.5rem;
  text-align: center;
}

.holding>img {
  margin-bottom: 1.5rem;
  max-width: 100%;
  display: block;
}

.warning-late {
  text-align: center;
  background: #363636;
  color: #fff;
  font-size: 12px;
  padding: 5px;

  a {
    color: #fff;
    text-decoration: underline;
  }
}

.fadep-enter-active, .fadep-leave-active {
  transition-property: opacity;
  transition-duration: .23s;
}

.fadep-enter-active {
  transition-delay: .23s;
}

.fadep-enter, .fadep-leave-active {
  opacity: 0
}

.navbar-burger {
  width: 4.5rem;
  color: #74ba6c;
  display: block;

  span {
    width: 32px;
    height: 5px;
    border-radius: 20px;
    left: calc(50% - 16px);

    &:nth-child(1) {
      top: calc(50% - 10px);
    }
    &:nth-child(2) {
      /* top: calc(50% - 3px); */
    }
    &:nth-child(3) {
      top: calc(50% + 8px);
    }
  }
}
// .navbar-menu.is-active {
//   border-top: 1px solid #acddb0;
// }
.navbar-brand {
  border-bottom: 1px solid #acddb0;
}

.hero.is-fullheight {
  min-height: calc(100vh - 3.25rem);
  background: #7176bc;
  background: -moz-linear-gradient(top, #7176bc 0%, #ffffff 100%);
  background: -webkit-linear-gradient(top, #7176bc 0%,#ffffff 100%);
  background: linear-gradient(to bottom, #7176bc 0%,#ffffff 100%);
  filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#7176bc', endColorstr='#ffffff',GradientType=0 );
  color: #fff;

  .title {
    color: #fff;
  }

  text-align: center;
}

#app {
  font-family: 'Nunito', sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
}

.has-navbar-fixed-top .is-noscroll #app {
  padding-top: 3.25rem;
}

.modal {
  text-align: center;
  // justify-content: flex-end;
}
.modal-background {
  background-color: rgba(10, 10, 10, 0.7);
}
.modal-content, .modal-card {
  max-height: calc(100vh - 1rem);
}

.modal-close {
  top: 10px;
  right: 10px;
}
.delete::before, .modal-close::before, .delete::after, .modal-close::after {
  background-color: #000;
}
.card-content {
  padding-top: 2rem;
  padding-bottom: 1rem;
}


.navbar-burger.is-active span:nth-child(1) {
  transform: translateY(10px) rotate(-45deg);
}
.navbar-burger.is-active span:nth-child(3) {
  transform: translateY(-9px) rotate(45deg);
}


.lds-roller {
  display: inline-block;
  position: relative;
  width: 64px;
  height: 64px;
}
.lds-roller div {
  animation: lds-roller 1.2s cubic-bezier(0.5, 0, 0.5, 1) infinite;
  transform-origin: 32px 32px;
}
.lds-roller div:after {
  content: " ";
  display: block;
  position: absolute;
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background: #ae33b5;
  margin: -3px 0 0 -3px;
}
.lds-roller div:nth-child(1) {
  animation-delay: -0.036s;
}
.lds-roller div:nth-child(1):after {
  top: 50px;
  left: 50px;
}
.lds-roller div:nth-child(2) {
  animation-delay: -0.072s;
}
.lds-roller div:nth-child(2):after {
  top: 54px;
  left: 45px;
}
.lds-roller div:nth-child(3) {
  animation-delay: -0.108s;
}
.lds-roller div:nth-child(3):after {
  top: 57px;
  left: 39px;
}
.lds-roller div:nth-child(4) {
  animation-delay: -0.144s;
}
.lds-roller div:nth-child(4):after {
  top: 58px;
  left: 32px;
}
.lds-roller div:nth-child(5) {
  animation-delay: -0.18s;
}
.lds-roller div:nth-child(5):after {
  top: 57px;
  left: 25px;
}
.lds-roller div:nth-child(6) {
  animation-delay: -0.216s;
}
.lds-roller div:nth-child(6):after {
  top: 54px;
  left: 19px;
}
.lds-roller div:nth-child(7) {
  animation-delay: -0.252s;
}
.lds-roller div:nth-child(7):after {
  top: 50px;
  left: 14px;
}
.lds-roller div:nth-child(8) {
  animation-delay: -0.288s;
}
.lds-roller div:nth-child(8):after {
  top: 45px;
  left: 10px;
}
@keyframes lds-roller {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
.loading-container {
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 99;
  background: rgba(0, 0, 0, 0.70);
  display: flex;
  align-items: center;
  justify-content: center;
}
.loading-container-inner {
  background-color: #fff;
  padding: 2rem 3rem;
}
.waiting-text {
  padding-top: 1rem;
}
img.scene-item.green.green-rocket {
  bottom: -17% !important;
  transform: scale(1.5) !important;
}
.footer-container {
  padding: 1rem;
  /* text-align: left; */
}
.footer-disclaimer {
  font-size: 9px;
}

img.footer-logo {
  filter: brightness(10);
  width: 200px;
}

.footer-logos {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 2rem;
}

footer.footer {
  background-color: #909090;
  color: #fff;
  font-size: 0.8rem;
  text-align: left;
  padding-top: 2rem;
}
.feefo-logo {
  width: 120px;
}
img.footer-before {
  display: block;
  width: 100%;
  margin: 0;
}

.content p:not(:last-child),
.content dl:not(:last-child),
.content ol:not(:last-child),
.content ul:not(:last-child),
.content blockquote:not(:last-child),
.content pre:not(:last-child),
.content table:not(:last-child) {
  margin-bottom: 2rem;
}


.before-a--footer>path {
  fill: #909090;
}
.before-a--footer {
  transform: rotate(180deg);
}

p.footer-links {
  text-align: center;
}
a.footer-item {
  color: #fff;
  text-decoration: underline;
  margin: 0 1rem;
}

a.footer-item {
  display: inline-block;
}

@media screen and (max-width: 768px) {
  .modal .animation-content {
    width: calc(100% - 1rem);
  }
}

body, button, input, select, textarea {
  font-family: 'Nunito', sans-serif;
}

.button:active, .button.is-active {
  background: #23d160;
  color: #fff;
  border: 2px solid #2da557;
}

</style>
